<div mat-dialog-title style="margin:0px;">{{dialogTitle}}</div>

<mat-dialog-content style="margin-top: 15px;">
    <div class="flex-content" *ngIf="showSimpleGridData.length > 0" style="height: 100%;">
        <div style="overflow:auto;">
            <mat-table style="width:100%" #table [dataSource]="tylerMatData" multiTemplateDataRows
                class="mat-elevation-z8" matSort matSortDisableClear matSortActive="CategoryDescription"
                matSortDirection="asc">
                <ng-container matColumnDef="CategoryDescription">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px; max-width: 250px;">
                        <span translate>Category</span>
                        <filter class="mat-filter" [data]="tylerMatData" columnName="CategoryDescription"
                            dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 250px;">
                        {{element.CategoryDescription}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="DataBankDescription">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 250px;padding-left: 7px;">
                        <span translate>Description</span>
                        <filter class="mat-filter" [data]="tylerMatData" columnName="DataBankDescription"
                            dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="min-width: 250px;padding-left: 7px;">
                        {{element.DataBankDescription}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef style="min-width: 70px; max-width: 70px;padding-left: 10px;">
                        <span translate>Action</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="min-width: 70px; max-width: 70px;padding-left: 10px;">
                        <a class="link">Select</a>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnToDisplay; sticky: true">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" tabindex="0"
                    (click)="onRowSelect(row)" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple
                    class="element-row">
                </mat-row>
            </mat-table>
        </div>
    </div>
    <!--Else condition works here---->
    <div *ngIf="showGoalGridData.length > 0" class="flex-content" style="height: 100%;">
        <div style="overflow:auto;">
            <mat-table style="width:100%" #table [dataSource]="tylerMatData" multiTemplateDataRows
                class="mat-elevation-z8" matSort matSortDisableClear matSortActive="CategoryDescription"
                matSortDirection="asc">

                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px; max-width:68px; text-align:center;"
                        translate class="print-ignore">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="expandAllRow ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                                (click)="expandAllRowClick()" aria-hidden="true"></i>
                        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CL" style="min-width:75px;max-width:75px;text-align:center;color:black;"
                        class="print-ignore">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(CL) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                                aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CategoryDescription">
                    <mat-header-cell *matHeaderCellDef
                        style="display: flex; min-width: 150px; max-width: 200px;padding-left: 10px;padding-right: 10px;"
                        mat-sort-header>
                        <span translate>Category</span>
                        <filter class="mat-filter" [data]="tylerMatData" columnName="CategoryDescription"
                            dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CL"
                        style="display: flex; min-width: 150px; max-width: 200px;align-self: flex-start;padding-right: 10px;word-break: break-word">
                        {{CL.CategoryDescription}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DataBankDescription">
                    <mat-header-cell *matHeaderCellDef
                        style="display: flex; min-width: 150px; max-width: 1000px;padding-right: 10px" mat-sort-header>
                        <span translate>Description</span>
                        <filter class="mat-filter" [data]="tylerMatData" columnName="DataBankDescription"
                            dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CL"
                        style="display: flex; min-width: 150px; max-width: 1000px;align-self: flex-start;padding-right: 10px;word-break: break-word">
                        {{CL.DataBankDescription}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef style="min-width: 70px; max-width: 70px;">
                        <span translate>Action</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="min-width: 70px; max-width: 70px;">
                        <a class="link" (click)="onRowSelect(element)">Select</a>
                    </mat-cell>
                </ng-container>
                <!----------------------------Expanded Table----------------------------->

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let CL" [attr.colspan]="columnToDisplay.length" style="width:100%;"
                        class="mat-detail-card">

                        <mat-table [dataSource]="CL.child" multiTemplateDataRows class="mat-elevation-z8" id="childData"
                            style="width:100%;" matSort matSortDisableClear matSortActive="DataBankDescription"
                            tabindex="-1">

                            <ng-container matColumnDef="CheckBtn">
                                <mat-header-cell *matHeaderCellDef>
                                    <tyl-checkbox  (change)="checkAllClick(CL.child)" [(checked)]="allCheck">
                                    </tyl-checkbox>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let detail">
                                    <tyl-checkbox (change)="checkBoxClick(detail)"  [(checked)]="detail.StatusChecked">
                                    </tyl-checkbox>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="DataBankDescription">
                                <mat-header-cell *matHeaderCellDef>
                                    <span translate> Objective Description</span>

                                </mat-header-cell>
                                <mat-cell *matCellDef="let detail"
                                    style="display:flex; min-width: 150px; padding-right: 30px;align-self: flex-start;word-break: break-word">
                                    {{detail.DataBankDescription}}</mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="columToInnerGrid; sticky: true" id="goalHeader">
                            </mat-header-row>
                            <mat-row *matRowDef="let row; columns: columToInnerGrid; let i = index;" tabindex="0"
                                style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple
                                class="element-row">
                            </mat-row>
                        </mat-table>
                    </td>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnToDisplay; sticky: true">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" tabindex="0" matRipple
                    class="element-row" style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                    (keydown)="rowKeyPress($event, row)">
                </mat-row>

                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                    [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"
                    class="mat-detail-row">
                </mat-row>

            </mat-table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer">
        <div class="flex-footer-right">
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </div>
</mat-dialog-actions>